import { useLang } from '@/i18n';
import EcoBanner, { EcoBannerProps } from 'eco-design/sections/eco-banner-card';
export default function Comp() {
    const { t } = useLang('theProduct.BannerA');
    const dataA: EcoBannerProps = {
        layout: 'top-center',

        pc: 'https://websiteoss.ecoflow.com/upload/image/1745042174044/first_kv_1.jpg',
        h5: 'https://websiteoss.ecoflow.com/upload/image/1745042173922/first_kv_1_h5.jpg',
        labelColor: '#D11504',
        title: t('title1'),
        desc: t('desc1'),

        // 按钮
        lType: 'filled',
        lChildren: t('btn1'),
        lHref: 'https://www.ecoflow.com/jp/wave-3-and-glacier-classic',
        lBtnIsYouToBe: false,

        className: 'banner-card-a',
        lDataLayer: {
            event: 'uaEvent',
            event_name: 'select_product',
            list_name: 'Product Preview',
            product_name: 'wave-3-and-glacier-classic',
            button_name: t('btn1'),
        },
    };
    return (
        <>
            <EcoBanner {...dataA} />
        </>
    );
}
